import React, { useState, useEffect } from "react";
import Form from 'react-bootstrap/Form';
import '../assets/css/home.css';
const HomeV2 = () => {
    const [value, setValue] = useState(0);

    const images = [
        "/home_images_v2/00.jpg",
        "/home_images_v2/01.jpg",
        "/home_images_v2/02.jpg",
        "/home_images_v2/03.jpg",
        "/home_images_v2/04.jpg",
        "/home_images_v2/05.jpg",
        "/home_images_v2/06.jpg",
        "/home_images_v2/07.jpg",
        "/home_images_v2/08.jpg",
        "/home_images_v2/09.jpg",
        "/home_images_v2/10.jpg",
        "/home_images_v2/11.jpg",
        "/home_images_v2/12.jpg",
        "/home_images_v2/13.jpg",
        "/home_images_v2/14.jpg",
        "/home_images_v2/15.jpg",
        "/home_images_v2/16.jpg",
        "/home_images_v2/17.jpg",
        "/home_images_v2/18.jpg",
        "/home_images_v2/19.jpg",
        "/home_images_v2/20.jpg",
        "/home_images_v2/21.jpg",
        "/home_images_v2/22.jpg",
        "/home_images_v2/23.jpg",
        "/home_images_v2/24.jpg",
        "/home_images_v2/25.jpg",
        "/home_images_v2/26.jpg",
        "/home_images_v2/27.jpg",
        "/home_images_v2/28.jpg",
        "/home_images_v2/29.jpg",
        "/home_images_v2/30.jpg",
        "/home_images_v2/31.jpg",
        "/home_images_v2/32.jpg",
        "/home_images_v2/33.jpg",
        "/home_images_v2/34.jpg",
        "/home_images_v2/35.jpg",
        "/home_images_v2/36.jpg",
        "/home_images_v2/37.jpg",
        "/home_images_v2/38.jpg",
        "/home_images_v2/39.jpg",
        "/home_images_v2/40.jpg",
        "/home_images_v2/41.jpg",
        "/home_images_v2/42.jpg",
        "/home_images_v2/43.jpg",
        "/home_images_v2/44.jpg",
        "/home_images_v2/45.jpg",
        "/home_images_v2/46.jpg",
        "/home_images_v2/47.jpg",
        "/home_images_v2/48.jpg",
        "/home_images_v2/49.jpg",
        "/home_images_v2/50.jpg",
        "/home_images_v2/51.jpg",
        "/home_images_v2/52.jpg",
        "/home_images_v2/53.jpg",
        "/home_images_v2/54.jpg",
        "/home_images_v2/55.jpg",
        "/home_images_v2/56.jpg",
        "/home_images_v2/57.jpg",
        "/home_images_v2/58.jpg",
        "/home_images_v2/59.jpg",
        "/home_images_v2/60.jpg",
    ];
    useEffect(() => {
        images.forEach((src) => {
            const img = new Image();
            img.src = src;
        });
    }, []);

    return (
        <div className="full-container">
            <img src={`/home_images_v2/${String(value).padStart(2, "0")}.jpg`} alt="" className="home_page_images rotate_view" />
            <div className="home-slider-container">
                <Form.Range min={0} max={60} value={value}
                    onChange={(e) => setValue(e.target.value)} className="home_range_slider" />
            </div>
        </div>
    )
}

export default HomeV2;